import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot } from "@angular/router";
import { AuthService } from "../shared/services/superadminusers/auth.service";
import { getTokenData } from "../shared/services/utils/utils";

@Injectable({
    providedIn: 'root',
})
export class LoggedInAuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
        console.log("LoggedInAuthGuard initialized");
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const isSuperAdminRoute = route.routeConfig?.path?.includes('superadmin');

        // Handle superadmin routes
        if (isSuperAdminRoute && this.authService.isSuperAdminLoggedIn()) {
            this.router.navigate(['/superadmin/dashboard']);
            return false;
        }

        // Handle portal user routes
        if (!isSuperAdminRoute && this.authService.isPortalUserLoggedIn()) {
            const tokenData = getTokenData();

            if (!tokenData || !tokenData?.role) {
                this.router.navigate(['/access-denied']);
                return false;
            }



            if (tokenData.role === 'User') {
                this.router.navigate(['/portal/category-courses']);
            } else {
                if (tokenData?.companyData?.isFreeTrial === true) {
                    this.router.navigate(['/portal/category-courses']);
                } else {
                    this.router.navigate(['/portal/dashboard']);

                }
            }
            return false;
        }

        return true;
    }
}
